export const hasInvalidChars = (key: string, blockedChars: String[]) => {
    // Block if key doesn't match allowed pattern
    if (blockedChars.includes(key)) {
        return true;
    }
    return false;
};
